/*
 * Rules for a team's serviceman-app username (stored in employee.username)
 * and password. The panel API enforces the same rules and messages in
 * fleetnexis-panel-api/utils/teamCredentials.js; keep the two in step.
 */

export const USERNAME_MIN = 3;
export const USERNAME_MAX = 20;
export const PASSWORD_MIN = 6;
export const PASSWORD_MAX = 32;

export const normalizeUsername = (value) => String(value ?? '').trim().toLowerCase();

// Checked in order; the first failing rule is the message shown.
export const usernameError = (value) => {
  const username = normalizeUsername(value);
  if (!username) return 'Username is required.';
  if (username.length < USERNAME_MIN) return `Username must be at least ${USERNAME_MIN} characters.`;
  if (username.length > USERNAME_MAX) return `Username must be at most ${USERNAME_MAX} characters.`;
  if (/\s/.test(username)) return 'Username cannot contain spaces.';
  if (!/^[a-z0-9._-]+$/.test(username)) return 'Username can only use letters, numbers, ".", "_" and "-".';
  if (!/^[a-z0-9]/.test(username) || !/[a-z0-9]$/.test(username)) {
    return 'Username must start and end with a letter or number.';
  }
  if (/[._-]{2}/.test(username)) return 'Username cannot have two symbols in a row.';
  return null;
};

// A blank password is only an error when one is required (adding a team);
// on edit it means "keep the current password".
export const passwordError = (value, { required }) => {
  const password = String(value ?? '');
  if (!password) return required ? 'Password is required.' : null;
  if (password.length < PASSWORD_MIN) return `Password must be at least ${PASSWORD_MIN} characters.`;
  if (password.length > PASSWORD_MAX) return `Password must be at most ${PASSWORD_MAX} characters.`;
  if (/\s/.test(password)) return 'Password cannot contain spaces.';
  return null;
};
